import { db, DefectReportType } from 'technical/db';

export const defectReportTypeSyncService = {
  async download(types: DefectReportType[]): Promise<void> {
    await db.defectReportTypes.bulkPut(types);
  },

  async reset(): Promise<void> {
    await db.defectReportTypes.clear();
  },
};
